import { useRouter } from '../router/MarketplaceRouter';

export function MarketplaceFooter() {
  const { navigate } = useRouter();

  const colHeading: React.CSSProperties = {
    fontFamily: 'var(--font-family-body)',
    fontSize: '0.75rem',
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: '0.08em',
    color: 'var(--color-text-muted)',
    marginBottom: '1rem',
  };

  const link: React.CSSProperties = {
    all: 'unset',
    cursor: 'pointer',
    fontSize: '0.9375rem',
    color: 'var(--color-text-secondary)',
    lineHeight: 2,
    display: 'block',
  };

  return (
    <footer
      style={{
        marginTop: '6rem',
        background: 'var(--color-background-surface)',
        borderTop: '1px solid var(--color-border-light)',
      }}
    >
      <div
        style={{
          maxWidth: '1240px',
          margin: '0 auto',
          padding: '4.5rem 1.5rem 2.5rem',
        }}
      >
        {/* Top: tagline + columns */}
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'minmax(260px, 1.4fr) repeat(4, minmax(120px, 1fr))',
            gap: '3rem',
            marginBottom: '3.5rem',
          }}
          className="footer-grid"
        >
          {/* Brand */}
          <div>
            <div
              style={{
                display: 'flex',
                alignItems: 'baseline',
                gap: '0.3rem',
                marginBottom: '1rem',
              }}
            >
              <span
                style={{
                  fontFamily: 'var(--font-family-display)',
                  fontSize: '1.875rem',
                  fontStyle: 'italic',
                  fontWeight: 400,
                  letterSpacing: '-0.02em',
                  color: 'var(--color-text-primary)',
                  lineHeight: 1,
                }}
              >
                baza
              </span>
              <span
                style={{
                  width: '7px',
                  height: '7px',
                  borderRadius: '999px',
                  background: 'var(--color-accent-rosegold)',
                  marginBottom: '3px',
                }}
              />
            </div>
            <p
              style={{
                fontSize: '0.9375rem',
                lineHeight: 1.65,
                color: 'var(--color-text-secondary)',
                maxWidth: '320px',
                margin: 0,
              }}
            >
              A vendor marketplace for the people who take home renovation seriously. Verified studios, honest quotes, and weekly updates on camera.
            </p>
          </div>

          {/* Columns */}
          <div>
            <div style={colHeading}>Marketplace</div>
            <button style={link} onClick={() => navigate('browse')}>
              Browse categories
            </button>
            <button style={link} onClick={() => navigate('services')}>
              All services
            </button>
            <button style={link} onClick={() => navigate('request')}>
              Post a request
            </button>
          </div>

          <div>
            <div style={colHeading}>Vendors</div>
            <button style={link} onClick={() => navigate('signup')}>
              Join as a vendor
            </button>
            <button style={link} onClick={() => navigate('dashboard')}>
              Vendor dashboard
            </button>
            <a style={link}>Verification</a>
          </div>

          <div>
            <div style={colHeading}>Company</div>
            <a style={link}>About Baza</a>
            <a style={link}>Press</a>
            <a style={link}>Journal</a>
            <a style={link}>Careers</a>
          </div>

          <div>
            <div style={colHeading}>Baku HQ</div>
            <div style={{ fontSize: '0.9375rem', color: 'var(--color-text-secondary)', lineHeight: 2 }}>
              Nizami 23, Baku
              <br />
              hello@baza.az
              <br />
              +994 12 000 00 00
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: '1rem',
            paddingTop: '2rem',
            borderTop: '1px solid var(--color-border-light)',
            fontSize: '0.8125rem',
            color: 'var(--color-text-muted)',
          }}
        >
          <span>© 2026 Baza Marketplace. Made in Baku.</span>
          <div style={{ display: 'flex', gap: '1.5rem' }}>
            <a style={{ all: 'unset', cursor: 'pointer' }}>Terms</a>
            <a style={{ all: 'unset', cursor: 'pointer' }}>Privacy</a>
            <a style={{ all: 'unset', cursor: 'pointer' }}>Trust & safety</a>
          </div>
        </div>
      </div>

      <style>{`
        @media (max-width: 900px) {
          .footer-grid {
            grid-template-columns: 1fr 1fr !important;
            gap: 2rem !important;
          }
        }
        @media (max-width: 560px) {
          .footer-grid {
            grid-template-columns: 1fr !important;
          }
        }
      `}</style>
    </footer>
  );
}
